import React, { useLayoutEffect, useRef } from "react";
import CohortCard from "./CohortCard";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedCohort } from "../../../../rtk-query/features/cohort/cohortSlice";
import exportimages from "../../../../assets/images/exportImages";
import { fnCheckDollarUnits } from "../../report/widget/widgetsCommonFunction";

const CustomCohort = ({ cohortList }) => {
  const dispatch = useDispatch();
  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  const firstSelectedRef = useRef(null);
  useLayoutEffect(() => {
    if (!firstSelectedRef.current) return;

    requestAnimationFrame(() => {
      firstSelectedRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });
  }, [selectedCohort?.uid, cohortList?.length]);

  return (
    <div className="list-cohort">
      {cohortList?.length > 0 ? (
        cohortList?.map((cohort) => {
          const cohort_Result = cohort?.cohort_Result;
          const filter_Json = cohort?.filter_Json;
          const { score: minAssetSize, unit: minAssetSizeUnit } =
            fnCheckDollarUnits(Number(filter_Json?.assets?.min) ?? 0);
          const { score: maxAssetSize, unit: maxAssetSizeUnit } =
            fnCheckDollarUnits(Number(filter_Json?.assets?.max) ?? 0);
          const isSelected = selectedCohort?.uid === cohort?.uid;

          return (
            cohort?.cohort_Type === 2 && (
              <div
                key={cohort.uid}
                ref={isSelected ? firstSelectedRef : null}
                onClick={() => {
                  dispatch(setSelectedCohort(cohort));
                }}
                className="w-100"
              >
                <CohortCard
                  uid={cohort?.uid}
                  title={cohort?.name}
                  subtitle={cohort?.description}
                  range={`$${minAssetSize?.toFixed(2)}${minAssetSizeUnit} – $${maxAssetSize?.toFixed(2)}${maxAssetSizeUnit}`}
                  // range={`$${filter_Json?.assets?.min} – $${filter_Json?.assets?.max}`}
                  institutions={cohort_Result?.institution_count}
                  avg={cohort_Result?.cohort_avg}
                  percentile={cohort_Result?.percentile}
                  isDeletable={true}
                />
              </div>
            )
          );
        })
      ) : (
        <div className="message-container">
          <div className="no_cohort">
            <img alt="icon" src={exportimages.no_cohort} />
          </div>
          <div className="message">No Custom Cohorts Yet</div>
          <div className="desc">
            You haven't created any cohorts. Use filters to shape your own
            cohort or duplicate a suggested one to get started.
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomCohort;
